module.exports = __webpack_public_path__ + "img/4_lfw.ee8f3cf8.jpg";